import React from 'react'
import { ButtonAction } from 'pages/NotifyEvent/styles'
import { UserDataType } from 'types/autentication'
import { listOfRoles } from 'components/WithRoleAuthorization/WithRoleAuthorization'
import { isNotifiableDamage } from 'utils/damage'

export interface IReopenNotification {
    currentUser: UserDataType
    notificationStatusState: string
    handleReopenNotification: () => void
    actionsBack: string
    isDirty: boolean
    isDirtyStyle: string
    damageLevelValue?: string
    isNotifiableCircumstance?: boolean
    canReopen?: boolean
}

export default function ReopenNotification({
    currentUser,
    notificationStatusState,
    handleReopenNotification,
    actionsBack,
    isDirty,
    isDirtyStyle,
    damageLevelValue,
    isNotifiableCircumstance,
    canReopen = true
}: IReopenNotification) {
    const isNotifiable =
        isNotifiableCircumstance ?? isNotifiableDamage(damageLevelValue)

    const canReopenByRole =
        currentUser?.profile === listOfRoles.admin ||
        currentUser?.profile === listOfRoles.corporate_quality_management ||
        (currentUser?.profile === listOfRoles.location_qa && isNotifiable)

    // Verificar se a notificação está finalizada ou arquivada
    const isFinishedOrArchived = notificationStatusState === 'Finalizada' || 
                                notificationStatusState === 'Arquivada'

    // Só renderiza o botão se o usuário tem permissão e a notificação está finalizada/arquivada
    if (!canReopenByRole || !isFinishedOrArchived || !canReopen) {
        return null
    }

    return (
        <ButtonAction
            data-testid="test-reopen-notification-button"
            type="button"
            onClick={handleReopenNotification}
            className={`text-[#DF8D2C] border-[#DF8D2C] bg-white hover:bg-[#DF8D2C] hover:text-white w-[167px] justify-center ${isDirty ? isDirtyStyle : ''}`}
            disabled={isDirty}
        >
            Reabrir notificação
        </ButtonAction>
    )
}
